import { useLang } from "../lib/i18n";

const FlagES = () => (
  <svg viewBox="0 0 24 16" className="w-6 h-4" aria-hidden="true">
    <rect width="24" height="16" fill="#AA151B" />
    <rect y="4" width="24" height="8" fill="#F1BF00" />
  </svg>
);

const FlagUK = () => (
  <svg viewBox="0 0 60 30" className="w-6 h-4" aria-hidden="true">
    <clipPath id="uk-clip"><path d="M0 0v30h60V0z" /></clipPath>
    <path d="M0 0v30h60V0z" fill="#012169" />
    <path d="M0 0l60 30m0-30L0 30" stroke="#fff" strokeWidth="6" clipPath="url(#uk-clip)" />
    <path d="M0 0l60 30m0-30L0 30" stroke="#C8102E" strokeWidth="4" clipPath="url(#uk-clip)" />
    <path d="M30 0v30M0 15h60" stroke="#fff" strokeWidth="10" />
    <path d="M30 0v30M0 15h60" stroke="#C8102E" strokeWidth="6" />
  </svg>
);

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();
  const btn = (code, Flag, label) => (
    <button
      type="button"
      onClick={() => setLang(code)}
      aria-label={label}
      title={label}
      aria-pressed={lang === code}
      className={`p-1 transition-opacity ${lang === code ? "opacity-100 ring-1 ring-[#1E3A5F]" : "opacity-45 hover:opacity-90"}`}
      data-testid={`lang-${code}`}
    >
      <Flag />
    </button>
  );
  return (
    <div className="flex items-center gap-1" data-testid="language-switcher">
      {btn("es", FlagES, "Español")}
      {btn("en", FlagUK, "English")}
    </div>
  );
};
